import axios from 'axios'

import {
  responseSuccess,
  responseError,
  beforeRequest
} from '@/services/config/ApiAdminInterceptors'

const API_ADMIN = process.env.API_ADMIN || ''

let ApiAdmin = axios.create({
  baseURL: API_ADMIN,
  headers: {
    'Accept': 'application/json; charset=utf-8',
    'Accept-Language': 'ru-RU,ru;q=0.5',
    'Content-Type': 'application/json'
  }
})
ApiAdmin.interceptors.request.use(beforeRequest)
ApiAdmin.interceptors.response.use(responseSuccess, responseError)

export default ApiAdmin



// WEBPACK FOOTER //
// ./src/services/config/ApiAdmin.js